import React, { useContext, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import StarekContext from "../context/StarekContext";
import { queryAuthenticated } from "../services/GraphService";

import AddPlantWizard from "../components/Wizards/AddPlantWizard";
import FullPageLoader from "../components/FullPageLoader";
import "bootstrap/dist/css/bootstrap.min.css";
import "../starek.css";
import PlantViewCard from "../components/PlantViewCard";
import StarekPlansModal from "../components/StarekPlansModal";
import AddPlantModal from "../components/Wizards/AddPlantModal";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { gql, useQuery } from "@apollo/client";

const GET_PLANTS_LIST = gql`
    query GetPlants {
        plants {
            id
            name
            description
            is_active
            zones {
                name
                id
                parent_id
                description
                created_at
            }
            shifts {
                name
                id
                start_time
                end_time
                runs_on
            }
        }
    }
`;

const ChoosePlant = (props) => {
    const starekContext = useContext(StarekContext);
    const navigator = useNavigate();

    const { data, loading, error, refetch } = useQuery(GET_PLANTS_LIST, {
        client: starekContext.engineClient,
        onCompleted: (fetchedData) => {
            starekContext.setAvailablePlants(fetchedData.plants);
        },
    });

    const [isAdding, setIsAdding] = useState(false);
    const [disableClose, setDisableClose] = useState(false);
    const [item, setItem] = useState([]);
    const [selected, setSelected] = useState(false);
    const [showPlansModal, setShowPlansModal] = useState(false);
    const [showModifyPlantModal, setShowModifyPlantModal] = useState(false);
    const [slideOut, setSlideOut] = useState(false);
    const [plantToEdit, setPlantToEdit] = useState(null);

    const onClose = async () => {
        setIsAdding(false);
    };
    const handleShowPlansModalClose = () => setShowPlansModal(false);
    const handleShowPlansModalShow = () => setShowPlansModal(true);
    const handleShowModifyPlantModalClose = () =>
        setShowModifyPlantModal(false);
    const handleShowModifyPlantModalShow = () => setShowModifyPlantModal(true);
    const handleCardClick = async (plantData) => {
        setSlideOut(true);
        await starekContext.setLastUsedPlant(plantData);
        setTimeout(() => {
            const redirectPath =
                sessionStorage.getItem("postAuthRedirect") || "/";
            navigator(redirectPath);
        }, 500);
    };
    const handleEditPlant = (plantData) => {
        setPlantToEdit(plantData);
        setShowModifyPlantModal(true);
    };
    const handleDeletePlant = (plantData) => {};
    const plantsList = data?.plants ?? starekContext.availablePlants ?? [];

    useEffect(() => {
        if (data?.plants) {
            starekContext.setAvailablePlants(data.plants);
        }
    }, [data]);
    if (loading)
        return (
            <div>
                <FullPageLoader />
            </div>
        );
    return (
        <SwitchTransition>
            <CSSTransition
                key={slideOut ? "exit" : "enter"}
                timeout={500}
                classNames={{
                    enter: "page-enter",
                    enterActive: "page-enter-active",
                    exit: "page-exit",
                    exitActive: "page-exit-active",
                }}
            >
                <div className="transition-container">
                    <div>
                        <div>&nbsp;</div>
                        <h2 className="text-center">
                            {starekContext.lastUsedWorkspace.name} - Available
                            Plants
                        </h2>
                        <div className="bg-light d-flex justify-content-between align-items-center px-3 py-2 ">
                            <div>
                                {starekContext?.lastUsedWorkspace?.licenses?.map(
                                    (license, index) => {
                                        return (
                                            <div key={index}>
                                                <div
                                                    className="font-weight-bold"
                                                    key={index}
                                                >
                                                    {license.name}
                                                </div>
                                                <div>
                                                    {
                                                        starekContext
                                                            ?.availablePlants
                                                            ?.length
                                                    }
                                                    /
                                                    {!!license.plants
                                                        ? license.plants
                                                        : "Unlimited"}{" "}
                                                    plants added{" "}
                                                    {starekContext
                                                        ?.availablePlants
                                                        ?.length >= 8 && (
                                                        <span className="bg-danger rounded text-white px-2 py-1">
                                                            Nearing Limit
                                                        </span>
                                                    )}{" "}
                                                    {starekContext
                                                        ?.availablePlants
                                                        ?.length === 10 && (
                                                        <span className="bg-danger rounded text-white px-2 py-1">
                                                            Limit Exhausted
                                                        </span>
                                                    )}{" "}
                                                    |{" "}
                                                    {!!license.devices
                                                        ? license.devices
                                                        : "Unlimited"}{" "}
                                                    Devices
                                                </div>
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                            <div>
                                <button
                                    className="btn btn-outline-primary"
                                    onClick={handleShowPlansModalShow}
                                >
                                    <i className="fa fa-crown mr-2"></i>View
                                    Plans
                                </button>
                                <button
                                    className="btn btn-primary ms-2"
                                    onClick={handleShowModifyPlantModalShow}
                                >
                                    <i className="fa fa-plus mr-2"></i>Add Plant
                                </button>
                            </div>
                        </div>
                        <div>&nbsp;</div>
                        <div>
                            <div className="col-xl-10 col-12 offset-xl-1 px-4">
                                <div
                                    className="row"
                                    style={{ minHeight: "250px" }}
                                >
                                    {!loading && (
                                        <>
                                            {plantsList.length === 0 ? (
                                                <div className="d-flex">
                                                    There are no plants defined!
                                                    Let us start by{" "}
                                                    <a
                                                        href="#"
                                                        onClick={
                                                            handleShowModifyPlantModalShow
                                                        }
                                                    >
                                                        defining a plant!
                                                    </a>
                                                </div>
                                            ) : (
                                                plantsList.map(
                                                    (plant, index) => (
                                                        <PlantViewCard
                                                            key={index}
                                                            plant={plant}
                                                            onCardClick={
                                                                handleCardClick
                                                            }
                                                            onEdit={
                                                                handleEditPlant
                                                            }
                                                            onDelete={
                                                                handleDeletePlant
                                                            }
                                                            onSuccess={() =>
                                                                refetch()
                                                            }
                                                        />
                                                    )
                                                )
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {isAdding && (
                            <AddPlantWizard
                                onClose={onClose}
                                disableClose={disableClose}
                            ></AddPlantWizard>
                        )}
                        {selected && (
                            <div
                                role="dialog"
                                aria-modal="true"
                                className="fade modal show"
                                tabIndex={-1}
                                style={{ display: "block" }}
                            >
                                <div
                                    className="modal-dialog-centered"
                                    style={{ width: "50%", margin: "auto" }}
                                >
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <div className="modal-title h4">
                                                <h3>Plant</h3>
                                            </div>
                                            <button
                                                type="button"
                                                className="close"
                                                onClick={() => {
                                                    setSelected(false);
                                                }}
                                            >
                                                <i className="fa fa-times nav-icon"></i>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <section className="content">
                                                <div className="form-group">
                                                    <label htmlFor="plant.name">
                                                        Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="plant.name"
                                                        onChange={(e) => {
                                                            setItem({
                                                                ...item,
                                                                name: e.target
                                                                    .value,
                                                            });
                                                        }}
                                                        value={
                                                            item.name
                                                                ? item.name
                                                                : ""
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Description</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="3"
                                                        id="plant.description"
                                                        value={
                                                            item.description
                                                                ? item.description
                                                                : ""
                                                        }
                                                        onChange={(e) => {
                                                            setItem({
                                                                ...item,
                                                                description:
                                                                    e.target
                                                                        .value,
                                                            });
                                                        }}
                                                    ></textarea>
                                                </div>
                                            </section>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                className="btn btn-sm btn-info btn-primary pull-left"
                                                onClick={async () => {
                                                    //savePlantData();
                                                }}
                                            >
                                                Update
                                            </button>{" "}
                                            <button
                                                className="btn btn-sm btn-info pull-left"
                                                onClick={async () => {
                                                    setSelected(false);
                                                }}
                                            >
                                                Close
                                            </button>{" "}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {showPlansModal && (
                        <StarekPlansModal
                            show={showPlansModal}
                            handleClose={handleShowPlansModalClose}
                        />
                    )}
                    {showModifyPlantModal && (
                        <AddPlantModal
                            show={showModifyPlantModal}
                            handleClose={() => {
                                setShowModifyPlantModal(false);
                                setPlantToEdit(null);
                            }}
                            onSuccess={() => {
                                refetch();
                            }}
                            plantData={plantToEdit}
                            mode={plantToEdit ? "edit" : "add"}
                        />
                    )}
                </div>
            </CSSTransition>
        </SwitchTransition>
    );
};

export default ChoosePlant;
